<template>
  <!-- Add/Edit Routing Transaction -->
  <div>
    <!-- List Routing Popup -->
    <el-dialog
      title="Routing"
      :visible.sync="routingDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-group-title">Từ Folio</div>
          <InfoList :columns="3">
            <InfoListLabel>Mã đặt phòng</InfoListLabel>
            <InfoListValue>{{ bookingInfo.sub_booking_code }}</InfoListValue>

            <InfoListLabel>Tên khách</InfoListLabel>
            <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

            <InfoListLabel>Số phòng</InfoListLabel>
            <InfoListValue>{{ bookingInfo.room_num }}</InfoListValue>
          </InfoList>
        </div>
      </div>
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="routingGrid"
          :columns="routingCols"
          :auto-size-cell="true"
          :auto-select-first-row="false"
          :row-multi-select-with-click="true"
          dom-layout="scroll"
          :rows="routingRows"
          class="agGrid"
          @selectionChanged="rowtingSelectionChanged"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="routingDialog = false"
          >
            Đóng
          </button>
          <button
            :disabled="routingSelectedRows.length === 0"
            class="btn primary small outline"
            @click="deleteRouting"
          >
            Xóa
          </button>
          <button
            :disabled="routingSelectedRows.length !== 1"
            class="btn primary small"
            @click="editRouting"
          >
            Sửa
          </button>
          <button class="btn primary small" @click="addRouting">Thêm</button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Chuyển Routing"
      :visible.sync="addRoutingDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-group-title">Chuyển từ</div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">Đặt phòng</div>
                    <span class="value">{{
                      bookingInfo.sub_booking_code
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">
                      <span class="required">Trang giao dịch</span>
                    </div>
                    <!-- <select v-model="createRoutingForm.trans_page_org">
                    <option
                      v-for="item in tabList"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select> -->
                    <validation-provider
                      style="width: 100%"
                      rules="required"
                      name="Trang giao dịch đi"
                    >
                      <el-select
                        v-model="createRoutingForm.trans_page_org"
                        placeholder=""
                      >
                        <el-option
                          v-for="item1 in tabList.filter(
                            item => item.value !== 9999
                          )"
                          :key="item1.value"
                          :label="`${item1.label} - ${item1.desc}`"
                          :value="item1.value"
                        >
                        </el-option>
                      </el-select>
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">
                      <span>Mã giao dịch</span>
                    </div>
                    <el-select
                      v-model="createRoutingForm.transaction_id"
                      placeholder=""
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in transactionList"
                        :key="item.id"
                        :label="item.description"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <select v-model="createRoutingForm.transaction_id">
                    <option :value="null">Tất cả</option>
                    <option></option>
                    <option
                      v-for="item in transactionList"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.description }}
                    </option>
                  </select> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="das-form-input in-line">
                    <div class="label">
                      <span class="required">Mã GD phụ</span>
                    </div>
                    <el-select
                      v-model="createRoutingForm.sub_transaction_id"
                      placeholder=""
                    >
                      <el-option :key="9999" :value="null" label="Tất cả" />
                      <el-option
                        v-for="item in subTransactionList"
                        :key="item.id"
                        :label="`${item.description}-(${item.code})`"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <select v-model="createRoutingForm.sub_transaction_id">
                    <option :value="null">Tất cả</option>
                    <option
                      v-for="item in subTransactionList"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.description }}
                    </option>
                  </select> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-group">
            <div class="das-form-group-title">Chuyển đến</div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Đặt phòng</span>
                  </div>
                  <div style="display: flex; gap: 10px; width: 100%">
                    <validation-provider
                      style="width: 100%"
                      rules="required"
                      name="Thông tin đặt phòng"
                    >
                      <input
                        v-model="createRoutingForm.sub_booking_group_name_des"
                        type="text"
                        disabled
                      />
                    </validation-provider>
                    <das-button
                      color="primary"
                      size="small"
                      append-icon="search"
                      @click="searchRoomOnTransferTransactionDialog()"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input in-line">
                  <div class="label">
                    <span class="required">Trang giao dịch</span>
                  </div>
                  <validation-provider
                    style="width: 100%"
                    rules="required"
                    name="Trang giao dịch đến"
                  >
                    <el-select
                      v-model="createRoutingForm.trans_page_des"
                      placeholder=""
                    >
                      <el-option
                        v-for="item1 in allTranPages"
                        :key="item1.id"
                        :label="
                          item1.desc
                            ? `${item1.code} - ${item1.desc}`
                            : item1.code
                        "
                        :value="item1.id"
                      >
                      </el-option>
                    </el-select>
                  </validation-provider>
                  <!-- <select v-model="createRoutingForm.trans_page_des">
                  <option
                    v-for="item in tabList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addRoutingDialog = false"
          >
            Đóng
          </button>
          <button
            v-if="isEditRouting"
            class="btn primary small"
            @click="onRoutingUpdate"
          >
            Cập nhật
          </button>
          <button v-else class="btn primary small" @click="onRoutingSubmit">
            Đồng ý
          </button>
        </div>
      </span>
    </el-dialog>
    <search-folio-component
      ref="searchFolioComponent"
      :search-folio-component-index="searchFolioComponentIndex"
      @onFolioSelect="onFolioSearchSelect"
    />
  </div>
</template>

<script>
import { getTransactionListApi } from '@/api/Transaction/transaction'
import { getListSubTransactionApi } from '@/api/configuration/accounting/subTransaction'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import SearchFolioComponent from './searchFolioComponent.vue'

import {
  postRouting,
  updateRouting,
  getRoutingList,
  deleteRouting
} from '@/api/cashier_service/postTransaction'
import { getRoomLevel, getRoom } from '@/api/reception/common'
import DasButton from '@/components/ui/DasButton.vue'
export default {
  components: {
    DasButton,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    SearchFolioComponent
  },
  props: {
    routingIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      searchFolioComponentIndex: 0,
      routingSelectedRows: [],
      isEditRouting: false,
      routingDialog: false,
      addRoutingDialog: false,
      searchFolioType: 1,
      createRoutingForm: {
        trans_page_org: null,
        sub_booking_group_id_org: null,
        trans_page_des: null,
        sub_booking_group_id_des: null,
        sub_booking_group_name_des: null,
        transaction_id: null,
        sub_transaction_id: null
      },
      routingCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.fromPageTransaction'),
          field: 'trans_page_org_code',
          tooltipField: 'trans_page_org_code',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'transaction_code',
          tooltipField: 'transaction_code',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.subTransactionCode'),
          field: 'sub_transaction_code',
          tooltipField: 'sub_transaction_code',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.toFolio'),
          field: 'sub_booking_group_des_code',
          tooltipField: 'sub_transaction_code',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.toPageTransaction'),
          field: 'trans_page_des_code',
          tooltipField: 'trans_page_des_code'
        }
        // {
        //   headerName: this.$t('grid.column.toRoom'),
        //   field: 'transaction_code'
        // }
      ],
      routingRows: [],
      transferTransactionSubmitForm: {
        trans_page: null,
        sub_booking_group_id: null,
        room_num: null,
        room_code: null,
        customer_name: null
      },
      transactionList: [],
      subTransactionList: []
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    tabList() {
      return this.$store.getters['tabList']
    },
    selectedTab() {
      return this.$store.getters['selectedTab']
    },
    allTranPages() {
      return this.$store.getters['allTranPages']
    },
    transactions() {
      return this.$store.getters['transactions']
    }
  },
  watch: {
    async 'createRoutingForm.transaction_id'() {
      this.subTransactionList = []
      this.createRoutingForm.sub_transaction_id = null
      const params = {
        transactionId: this.createRoutingForm.transaction_id
      }
      const data = await getListSubTransactionApi(params)
      this.subTransactionList = data.data ?? []
    },
    async routingIndex() {
      await this.getRoutingRows()
    },
    addRoutingDialog() {
      this.addRoutingDialog
        ? this.openRoutingDialog()
        : this.resetAddRoutingDialog()
    }
  },
  methods: {
    openRoutingDialog() {
      this.createRoutingForm.trans_page_org = this.tabList[0]?.value
      this.createRoutingForm.trans_page_des = this.allTranPages[0]?.id
    },
    onFolioSearchSelect(row) {
      this.createRoutingForm.sub_booking_group_id_des = row.id
      this.createRoutingForm.sub_booking_group_name_des = row.full_name
    },
    resetAddRoutingDialog() {
      this.isEditRouting = false
      this.$nullValueInObj(this.createRoutingForm)
    },
    rowtingSelectionChanged(rows) {
      this.routingSelectedRows = rows
    },
    async getRoutingRows() {
      const data = await getRoutingList(this.bookingInfo.id)
      this.routingRows = data?.data || []
      this.routingSelectedRows = []
    },
    async addRouting() {
      await this.getTransactions()
      this.addRoutingDialog = true
    },
    editRouting() {
      Object.assign(this.createRoutingForm, this.routingSelectedRows[0])
      this.isEditRouting = true
      this.addRoutingDialog = true
    },
    async deleteRouting() {
      const ids = this.routingSelectedRows.map(item => item.id) || []
      this.$vxConfirm(this.$t('alert.deleteRoutingConfirm'), async () => {
        await deleteRouting({
          ids: ids
        })
          .then(async res => {
            const message = res.message
            this.dialogFormVisible = false
            this.getRoutingRows()
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async getRoomLevelOptions() {
      const data = await getRoomLevel()
      this.roomLevelOptions = data?.data || []
      const data1 = await getRoom()
      this.roomOptions = data1.data
    },
    async getTransactions() {
      const data = await getTransactionListApi()
      this.transactionList = []
      data?.data.map(item => {
        if (!item.transaction_group_name) {
          this.transactionList.push(item)
        }
      })
    },
    async onRoutingSubmit() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      // this.routingDialog = false
      this.createRoutingForm.sub_booking_group_id_org = this.bookingInfo.id
      await postRouting(this.createRoutingForm)
        .then(async res => {
          const message = res.message
          await this.getRoutingRows()
          this.addRoutingDialog = false
          this.$store.dispatch('cashier/changeKey')
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onRoutingUpdate() {
      // this.routingDialog = false
      await updateRouting(this.createRoutingForm)
        .then(async res => {
          const message = res.message
          await this.getRoutingRows()
          this.addRoutingDialog = false
          this.$store.dispatch('cashier/changeKey')
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async searchRoomOnTransferTransactionDialog() {
      this.$refs.searchFolioComponent.searchFolioDialog = true
      this.searchFolioComponentIndex++
    }
  }
}
</script>
